import React, { useRef, useState } from "react";

import classNames from "classnames";

import { Tag } from "studio-design-system";
import { useWindowSize } from "usehooks-ts";

import { ArrowLeftIcon } from "~/components/common/Icons/ArrowLeftIcon";
import { ArrowRightIcon } from "~/components/common/Icons/ArrowRightIcon";

import * as styles from "./ScrollingTabs.css";

export const ScrollingTabs = ({
  tabs,
  setFilter,
}: {
  tabs: string[];
  setFilter: (tab: string) => void;
}): React.ReactElement => {
  const tabContainerRef = useRef<any>(null);
  const [selectedTab, setSelectedTab] = useState("All Classes");
  const [scrollLeft, setScrollLeft] = useState(0);
  const scroll = (scrollOffset: number, onlyUpdateState: boolean = false) => {
    if (!onlyUpdateState) {
      if (tabContainerRef.current) {
        let newScroll = scrollLeft + scrollOffset;
        tabContainerRef.current.scrollLeft = newScroll;
        setScrollLeft(newScroll);
      }
    } else {
      setScrollLeft(scrollOffset);
    }
  };

  const screen = useWindowSize();

  return (
    <div className={styles.container}>
      <div className={styles.tabWrap}>
        <div className={styles.arrowWrapLeft}>
          {scrollLeft >= 20 && (
            <div className={styles.hoverLeftArrows}>
              <div className={styles.arrowTag} onClick={() => scroll(-(screen.width / 4))}>
                <ArrowLeftIcon />
              </div>
            </div>
          )}
        </div>

        <div
          className={styles.tabContainer}
          ref={tabContainerRef}
          onScroll={(ev: any) => scroll(ev.target.scrollLeft, true)}
        >
          {tabs.map((tab, index) => (
            <Tag
              onClick={() => {
                if (tab == selectedTab) {
                  tab = "All Classes";
                }
                setSelectedTab(tab);
                setFilter(tab);
              }}
              className={classNames(styles.tab, selectedTab === tab && styles.selectedTab)}
              key={`tab_${index.toString()}`}
            >
              {tab}
            </Tag>
          ))}
        </div>

        {scrollLeft <
          tabContainerRef.current?.scrollWidth - tabContainerRef.current?.clientWidth && (
          <div className={styles.arrowWrapRight}>
            <div className={styles.hoverRightArrows}>
              <div className={styles.arrowTag} onClick={() => scroll(screen.width / 4)}>
                <ArrowRightIcon />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
